// LoginPage.js
import React from 'react';
import { Login, LoginForm } from 'react-admin';
import { withStyles } from '@material-ui/core/styles';

const styles = ({
    main: { background: '#333' },
    card: {
      minWidth: 300,
      marginTop: '6em',
      background: '#e3e3e3cf'
    },
    avatar: {
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        height: 40,
    },
});

const CustomLoginForm = withStyles({
  button: { background: '#F15922', margin: "20px"},
})(LoginForm);


const CustomLoginPage = props => (
    <Login style={{backgroundSize: 'cover'}}
        loginForm={<CustomLoginForm />}
        backgroundImage="/images/background2.jpg"
        {...props}
    />
);

export default withStyles(styles)(CustomLoginPage);
